<div
  *transloco="let t; read: 'dashboard-datasource-rules'"
  class="xi-modal__container datasource-rules__container"
>
  @if (isLoading) {
    <div class="xi-loader-container__inline-overlay xi-loader-container__inline-overlay--blur">
      <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
    </div>
  }

  <div class="xi-modal__title datasource-rules__header">
    <h2>{{ t('apply-data-source-rules') }}</h2>
    <div class="datasource-rules__dashboard-name">
      <xi-icon icon="reporting_filled" color="CX"></xi-icon>
      <div>{{ dashboard.title }}</div>
      <xi-icon icon="single_arrow_right"></xi-icon>
      <div>{{ t('all-pages') }}</div>
    </div>
  </div>

  <div class="xi-modal__content datasource-rules__content">
    <div class="datasource-rules__subtitle">
      <h3 class="kxi-text-normal">{{ t('subtitle') }}</h3>
    </div>

    <div class="datasource-rules__picker-container">
      <div class="datasource-rules__column-header">
        <h3>{{ t('available') }}</h3>
      </div>
      <div class="datasource-rules__column-content">
        <xi-search-box
          outline="none"
          (onChangeOverride)="onSearch($event.detail.searchText)"
        ></xi-search-box>
        <div class="datasource-rules__scroll-container">
          <xi-accordion>
            <div slot="children">
              @for (item of availableAccordions; track item.id) {
                <xi-accordion-item [title]="item.title">
                  <div slot="children">
                    @switch (item.templateType) {
                      @case ('checkbox') {
                        <ng-container
                          *ngTemplateOutlet="tCheckboxSelection; context: { $implicit: item.data }"
                        ></ng-container>
                      }
                      @case ('date') {
                        <ng-container
                          *ngTemplateOutlet="tDateSelection; context: { $implicit: item.data }"
                        ></ng-container>
                      }
                    }
                  </div>
                </xi-accordion-item>
              }
            </div>
          </xi-accordion>
        </div>
      </div>

      <div></div>
      <div class="datasource-rules__add-buttons-container">
        @if (selected.length > 0 && !isReadOnly) {
          @for (operator of operators; track operator) {
            <div class="datasource-rules__add-button-wrapper">
              <xi-icon-button
                icon="fab_plus"
                buttonSize="large"
                (onClick)="add(operator)"
              ></xi-icon-button>
            </div>
          }
        }
      </div>

      <div class="datasource-rules__column-header">
        <h3>{{ t('selected') }}</h3>
      </div>
      <div class="datasource-rules__column-content">
        <div class="datasource-rules__scroll-container">
          <ng-container
            *ngTemplateOutlet="
              tFilterSelection;
              context: { operator: 'and', header: t('all-of-these') }
            "
          ></ng-container>

          <ng-container
            *ngTemplateOutlet="
              tFilterSelection;
              context: { operator: 'or', header: t('any-of-these') }
            "
          ></ng-container>

          <ng-container
            *ngTemplateOutlet="
              tFilterSelection;
              context: { operator: 'not', header: t('none-of-these') }
            "
          ></ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="xi-modal__actions datasource-rules__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    @if (!isReadOnly) {
      <xi-default-button [text]="t('apply-rules')" (onClick)="onSave()"></xi-default-button>
    }
  </div>

  <ng-template #tCheckboxSelection let-options>
    @for (opt of options; track opt.id) {
      <div class="datasource-rules__checkbox-wrapper">
        <xi-checkbox
          [label]="opt.label"
          [value]="opt.id"
          [disabled]="isReadOnly"
          (onChange)="toggleSelected($event.detail.target.checked, opt)"
        ></xi-checkbox>
        @if (opt.type === 'label') {
          <span [matTooltip]="filterCounts[opt.type][opt.id].dsMatches">
            {{ filterCounts[opt.type][opt.id].count }}
          </span>
        } @else {
          <span [matTooltip]="filterCounts[opt.id]?.dsMatches">
            {{ filterCounts[opt.id]?.count }}
          </span>
        }
      </div>
    }
  </ng-template>

  <ng-template #tDateSelection let-options>
    @for (opt of options; track opt.id) {
      <div class="datasource-rules__checkbox-wrapper">
        <xi-checkbox
          [label]="opt.label"
          [value]="opt.id"
          [disabled]="!opt.value || isReadOnly"
          (onChange)="toggleSelected($event.detail.target.checked, opt)"
        ></xi-checkbox>
      </div>
      <div class="datasource-rules__checkbox-wrapper">
        <app-filter-date-calendar
          [filter]="opt"
          (filtersChange)="onDateValueChange($event, opt)"
        ></app-filter-date-calendar>
      </div>
    }
  </ng-template>

  <ng-template #tFilterSelection let-operator="operator" let-header="header">
    <div class="datasource-rules__selected-border"></div>
    <div class="datasource-rules_filter-selection-container">
      <div class="datasource-rules__filter-selection-header">
        <span class="kxi-text-normal kxi-text-600">{{ header }}</span>
        @if (!isReadOnly) {
          <xi-default-button
            fill="link"
            [text]="t('clear')"
            (onClick)="onClearAppliedFilters(operator)"
          ></xi-default-button>
        }
      </div>

      <div class="datasource-rules__filter-section-content">
        <mat-chip-listbox>
          @for (item of displayedSelectedFilters[operator]; track item.id) {
            <ng-container
              *ngTemplateOutlet="tFilterPill; context: { item, operator }"
            ></ng-container>
          }
        </mat-chip-listbox>

        <ng-template #tFilterPill let-item="item" let-operator="operator">
          <app-dashboard-datasource-filter-pill
            [dsFilter]="item"
            [isReadOnly]="isReadOnly"
            (dsFilterAction)="onFilterAction($event, operator, item)"
          ></app-dashboard-datasource-filter-pill>
        </ng-template>
      </div>
    </div>
  </ng-template>
</div>
